import { useQuery } from '@tanstack/react-query';
import { Alert, Flex, Typography } from 'antd';
import PropTypes from 'prop-types';
import { getExpenseExclusionMatches } from '../services/expense-exclusion';
import { describeExpenseExclusion } from '../utils/expense-exclusion';

const ExpenseExclusionMatches = ({ organizationId, eventId }) => {
  const { data, isPending, isError } = useQuery({
    queryKey: ['expense-exclusion-matches', organizationId, eventId],
    queryFn: () => getExpenseExclusionMatches(organizationId, eventId),
  });
  return (
    <Flex vertical gap="small">
      <Typography.Title level={5}>当前费用排除规则</Typography.Title>
      {isPending && <Typography.Text>加载中</Typography.Text>}
      {isError && <Alert type="error" message="排除规则加载失败，无法判断是否排除" />}
      {!isPending && !isError && (
        <>
          <Typography.Text>
            {data.length
              ? '此事件当前被排除，不参与指标计算；原始数据仍保留。'
              : '未命中启用的排除规则。'}
          </Typography.Text>
          {data.map((rule) => (
            <Typography.Text key={rule.id}>{describeExpenseExclusion(rule)}</Typography.Text>
          ))}
        </>
      )}
    </Flex>
  );
};
ExpenseExclusionMatches.propTypes = {
  organizationId: PropTypes.string.isRequired,
  eventId: PropTypes.string.isRequired,
};
export default ExpenseExclusionMatches;
